<template>
    <v-layout class="component-wrap">
        <EmployeeStudy />
    </v-layout>
</template>

<script>
import EmployeeStudy from '@/components/view_blocks/Employee_study/Employee_study_wrap';

export default {
  components: {
    EmployeeStudy,
  },
};
</script>
